import React, { useCallback, useState } from "react";
import axios from "axios";
import { Spinner } from "react-bootstrap";
import ReactPlayer from "react-player";

import batteryImage from "../img/solaredge-landingspage/icon-battery.png";
import moneyImage from "../img/solaredge-landingspage/icon-money-negative.png"
import sunnyImage from "../img/solaredge-landingspage/icon-sun.png";
import heroImage from "../img/solaredge-landingspage/solaredge-batterijen.png";

function SolarEdgeLandingsPage() {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phoneNumber: "",
        postalCode: "",
        houseNumber: "",
        street: "",
        city: "",
        message: "",
    });

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitSuccess, setSubmitSuccess] = useState(false);
    const [error, setError] = useState(null);

    const handleFormChange = useCallback((event) => {
        const { name, value } = event.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    }, []);

    const handleFormSubmit = useCallback((event) => {
        event.preventDefault();
        setError(null);
        setIsSubmitting(true);
        const data = { ...formData, type: "thuisbatterij-particulier" };

        axios.post("/submitSolarEdgeOfferteAanvraag", data)
            .then((response) => {
                if (response.data.valid) {
                    setIsSubmitting(false);
                    setSubmitSuccess(true);

                    setFormData({
                        name: "",
                        email: "",
                        phoneNumber: "",
                        postalCode: "",
                        houseNumber: "",
                        street: "",
                        city: "",
                        message: "",
                    });
                } else {
                    setIsSubmitting(false);
                    setError(response.data.error);
                }
            })
            .catch((requestError) => {
                console.error(requestError);
                setError("Er is een fout opgetreden bij het verzenden van het formulier. Probeer het later opnieuw.");
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    }, [formData]);

    const CardItem = ({ image, title, content }) => {
        return (
            <div className="card-item">
                <div className="card-item__link">
                    <div className="card-item__image">
                        <img src={image} alt={title} />
                    </div>
                    <div className="card-item__content">
                        <h4>{title}</h4>
                        <div className="card-item__text">
                            {typeof content === "string" ? <p>{content}</p> : content}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="solaredge-landingspage">

            {/* Main Content */}
            <main className="body-container-wrapper">
                <div className="container-fluid">
                    {/* Hero Section */}
                    <div className="hero-section">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-6 px-5">
                                    <h1 className="hero-title">
                                        <span className="highlight-text">CHARGE</span> JOUW WONING MET TWEE SOLAREDGE THUISBATTERIJEN VOOR MAAR{" "}
                                        <span className="price-text">€ 5.995,-*</span>
                                    </h1>

                                    <div className="mt-4">
                                        <p className="font-weight-bold">Wat houdt dit in?</p>

                                        <ul className="box">
                                            <li className="box">
                                                2x SolarEdge <strong>3-fase</strong> thuisbatterijen van totaal <strong>9.2kWh</strong> voor een uiterst scherpe prijs
                                            </li>
                                            <li className="box">
                                                Inclusief benodigdheden zoals een{" "}
                                                <a style={{ color: "#ff5000" }} target="_blank" rel="noopener" href="/producten/solaredge/">
                                                    Inline Meter
                                                </a>{" "}
                                                en ons EMS <a style={{ color: "#ff5000" }} target="_blank" rel="noopener" href="/ems/">Gridsense</a> voor een optimale werking
                                            </li>
                                            <li className="box">
                                                Geheel gemonteerd en geïnstalleerd
                                            </li>
                                            <li className="box">
                                                Indien jouw omvormer niet geschikt is voor een batterij, dan wordt deze nu <strong>gratis</strong> omgewisseld.
                                            </li>
                                        </ul>

                                        <p>
                                            <span className="font-weight-bold">Maar dat is nog niet alles.</span> Wist je dat je in aanmerking kunt komen voor eventuele <a style={{ color: "#ff5000" }} target="_blank" rel="noopener" href="/thuisbatterij/btwterugvraag/">BTW-teruggave?</a>
                                        </p>

                                        <p>
                                            Wil je het bedrag liever in delen investeren? Via het <span className="highlight-text">Warmtefonds</span> heb je al een thuisbatterij <span className="font-weight-bold">vanaf €46 per maand.</span> Kijk op{" "}
                                            <a
                                                style={{ color: "#ff5000" }}
                                                href="https://www.warmtefonds.nl/particulieren/energiebesparende-maatregelen/thuisbatterij"
                                                rel="noopener"
                                                target="_blank"
                                            >
                                                www.warmtefonds.nl
                                            </a>{" "}
                                            voor meer informatie.
                                        </p>

                                        <p className="disclaimer">
                                            <em>*De gegeven prijs is een adviesprijs excl. BTW en is gebaseerd op een standaard situatie. Onvoorziene aanvullende werkzaamheden en kosten zijn niet inbegrepen.</em>
                                        </p>
                                    </div>
                                </div>

                                <div className="col-md-6 d-flex justify-content-center align-items-center px-5 pb-5">
                                    <img
                                        src={heroImage}
                                        alt="SolarEdge Thuisbatterijen"
                                        className="img-fluid"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6 bg-white p-4">
                            <CardItem
                                image={moneyImage}
                                title="Betaal zo min mogelijk terugleververgoeding"
                                content="Tot de afschaffing van de salderingsregeling in 2027 betaal je een boete voor energie die je terug levert. Deze energie sla je beter zelf op met een thuisbatterij en gebruik je later zelf."
                            />

                            <CardItem
                                image={sunnyImage}
                                title="Bereid je voor op een zonnige toekomst"
                                content="Ondanks het afschaffen van de salderingsregeling, de terugleververgoeding of de overbelasting van het energienet (met eventuele uitval als gevolg) is de toekomst met een thuisbatterij altijd zonnig."
                            />

                            <CardItem
                                image={batteryImage}
                                title="Sla energie op en zorg dat je minder afhankelijk bent"
                                content="Met een thuisbatterij ben je minder afhankelijk van je energieleverancier en van de energieprijzen."
                            />

                            <div className="mt-4 mb-4">
                                <h3 className="gradient-title font-weight-bold">Je thuisbatterij als verdienmodel?</h3>
                                <p>Hoe je met een dynamisch energiecontract en een thuisbatterij het maximale rendement uit je zonnepanelen haalt, lees je <a href="/thuisbatterij/hoe-werkt-het/" style={{ color: "#ff5000" }} rel="noopener" target="_blank">hier.</a></p>
                                <p>Of bekijk onderstaande video:</p>

                                <div className="video-container">
                                    <ReactPlayer
                                        url="https://www.youtube.com/watch?v=2W445kaUkrc"
                                        width="100%"
                                        height="360px"
                                        controls={true}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6 bg-white p-4">
                            <div className="contact-form-container">
                                <div className="form-title">Vertel mij meer over de Charged UP actie</div>
                                <p>
                                    Wil je weten wat de voordelen voor jou zijn, vul dan het formulier in en wij nemen contact met je op.
                                </p>
                                {error && <div className="alert alert-danger">{error}</div>}

                                {submitSuccess ? (
                                    <div className="alert alert-success">
                                        Bedankt voor het verzenden van het formulier. Wij nemen spoedig contact met je op over de vervolgstappen.
                                    </div>
                                ) : (
                                    <form onSubmit={handleFormSubmit}>
                                        <div className="form-group">
                                            <label htmlFor="name">Naam*</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="name"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleFormChange}
                                                required
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="email">E-mail*</label>
                                            <input
                                                type="email"
                                                className="form-control"
                                                id="email"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleFormChange}
                                                required
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="phoneNumber">Telefoonnummer*</label>
                                            <input
                                                type="tel"
                                                className="form-control"
                                                id="phoneNumber"
                                                name="phoneNumber"
                                                value={formData.phoneNumber}
                                                onChange={handleFormChange}
                                                required
                                            />
                                        </div>

                                        <div className="form-row">
                                            <div className="form-group col-md-8">
                                                <label htmlFor="postalCode">Postcode*</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="postalCode"
                                                    name="postalCode"
                                                    value={formData.postalCode}
                                                    onChange={handleFormChange}
                                                    required
                                                />
                                            </div>
                                            <div className="form-group col-md-4">
                                                <label htmlFor="houseNumber">Huisnummer*</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="houseNumber"
                                                    name="houseNumber"
                                                    value={formData.houseNumber}
                                                    onChange={handleFormChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="form-row">
                                            <div className="form-group col-md-6">
                                                <label htmlFor="street">Straat*</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="street"
                                                    name="street"
                                                    value={formData.street}
                                                    onChange={handleFormChange}
                                                    required
                                                />
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label htmlFor="city">Stad*</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="city"
                                                    name="city"
                                                    value={formData.city}
                                                    onChange={handleFormChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="message">Bericht</label>
                                            <textarea
                                                className="form-control"
                                                id="message"
                                                name="message"
                                                rows="3"
                                                value={formData.message}
                                                onChange={handleFormChange}
                                            ></textarea>
                                        </div>

                                        <button
                                            type="submit"
                                            className="btn btn-primary submit-button"
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting ? <Spinner animation="border" variant="light" size="sm" className="mr-2"/> : "Verzenden"}
                                        </button>
                                    </form>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </main>

        </div>
    );
}

export default SolarEdgeLandingsPage;
